import moment from 'moment-timezone'

const utcOffsets = moment.tz.names().map(item => {
  return {
    value: item,
    label: item + '(' + moment.tz(item).utcOffset() / 60 + ')'
  }
})

const tagOptions = [
  'Run away line',
  'Non responsive line',
  'Divergence',
  'Disconnected line',
  'Saturated readings',
  'sit/stand inaccuracy',
  'sensor line drop',
  'Unexplained'
]

const pass = 'PASS'
const environments = {
  production: 'Production',
  staging: 'Staging'
}

const baseUrls = {
  baseUrl: 'https://data.smartzhealth.com',
  commonBaseUrl: 'https://configs.smartzhealth.com/api',
  reportBaseUrl: 'https://api.smartzhealth.com',
  signalRUrl: 'https://utility.smartzhealth.com/api'
}

const allPermissionAccount = 'simavita'

const subscriptionCodeStatus = {
  trial: 'TRIAL',
  approved: 'APPROVED',
  disabled: 'DISABLED'
}

const jobTypes = {
  backTestingVolumeEstimation: 'back-testing-volume-estimation',
  backTestingRedAlert: 'back-testing-redalert',
  backTestingNewPad: 'back-testing-newpad',
  modelGenerator: 'job-model-generator'
}

export {
  utcOffsets,
  baseUrls,
  allPermissionAccount,
  tagOptions,
  pass,
  environments,
  subscriptionCodeStatus,
  jobTypes
}
